import moment from 'moment';
import { MasterConfigs } from '../../interfaces/entity';
import { constants } from '../../constants/common';

export const emailTemplatesConfig: MasterConfigs = {
  api: () => '/cms/emailTemplates',
  title: 'Email Templates',
  isActionTab: true,
  modalTitle: (action) => `${action} Template`,
  getColumns: () => {
    return [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        isSearch: true,
      },
      {
        title: 'CC',
        dataIndex: 'cc',
        key: 'cc',
        type: 'viewList',
        render: (text) => {
          return text?.split(/[\s,;<>]+/);
        },
      },
      {
        title: 'BCC',
        dataIndex: 'bcc',
        key: 'bcc',
        type: 'viewList',
        render: (text) => {
          return text?.split(/[\s,;<>]+/);
        },
      },
      {
        title: 'Subject',
        dataIndex: 'subject',
        key: 'subject',
        type: 'viewText',
        render: (text) => {
          return text;
        },
      },
      {
        title: 'Approval Status',
        dataIndex: 'approvalStatus',
        key: 'approvalStatus',
        render: (value) => {
          return value == 'PENDING' ? 'Doesn\'t send for approval' : value;
        }
      },
      {
        title: 'Created At',
        dataIndex: 'createdAt',
        key: 'createdAt',
        render: (value) => {
          return moment(value).format('lll');
        }
      }
    ];
  },
  getFormColumns: () => {
    return [
      {
        label: 'Name',
        name: 'name',
        type: 'text',
        rules: [{ required: true, message: 'Field is required' }]
      },
      {
        label: 'Subject',
        name: 'subject',
        type: 'text',
        span: 24,
        rules: [{ required: true, message: 'Field is required' }]
      },
      {
        label: 'CC',
        name: 'cc',
        type: 'text',
      },
      {
        label: 'BCC',
        name: 'bcc',
        type: 'text',
      },
      {
        label: 'Description',
        name: 'description',
        type: 'quill',
        span: 24
      },
      {
        label: 'Attachment',
        name: 'attachments',
        type: 'file',
      },
    ];
  },
  combo: [
    {
      name: 'approvalFrom',
      api: '/users/CEO/list',
      idKey: '_id',
      render: text => constants.GET_FULL_NAME(text)
    }
  ],
  getData: () => ({}),
  actions: [
    { name: 'Add Template', actionType: 'Add' },
    { name: 'Return', actionType: 'Back' },
  ],
};
